/* eslint-disable no-unused-vars */
import React, { useState ,useEffect} from "react";
import { useTranslation } from 'react-i18next';
import searchIcon from '../../../assets/icons/search.svg';
import { DataGrid,EditModal } from "../../../common";
import { getCultureFromLs } from "../../../utils/commonFunctions";
import { APIEndpoint } from "../../../utils/axios";
import viewIcon from "../../../assets/view.svg";
import { useNavigate } from "react-router-dom";
import usePermissions from '../../../utils/userPermissions';
import moment from "moment";

const Columns = [
    {field: 'code', headerName: 'Code',resizable:true,flex:1,minWidth:210,cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    },},
    {field: '', headerName: 'Type',valueGetter: (params) => {
      return params.data?'Warehouse/InFlight':'';
    },flex:1},
    {field: 'createdAt',valueGetter: (params) => {
        return params.data?.createdAt?moment(params.data?.createdAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A'):'';
      }, headerName: 'Created At',flex:1},
    {field: 'createdBy',valueGetter: (params) => {
        return params.data?params.data.createdBy?.employeeName:"";
      }, headerName: 'Created By',flex:1},
    {field: 'unit',headerName: 'Summary',valueGetter: (params) => {
        return params.data?params.data.items.length+" items":"";
      },flex:1},
];
const EditFormFields = [
    {label: 'Csv', attribute: 'items', type: 'csv2', disabled: false, options: [], value: "" },
  ];
  const AddFormFields = [
    {label: 'Warehouse', attribute: 'warehouses', type: 'selectSearch2', disabled: false, options: [], required: true },
  ];
export const PilferageReporting = (props) => {
  const { t,ready } = useTranslation();
    const[state,setState]=useState();
    const navigate = useNavigate();
    const [pageLimit, ] = useState(50);
    const [searchKey, setSearchKey] = useState('');
    const [wareHouseArr,setWareHouseArr]=useState([]);
    const [isDropDownOpen,setIsDropdownOpen]=useState(false);
    const [ModalContHeight,setModalContHeight]=useState({height:'auto'})
  const [isReloadTableData, setIsReloadTableData ] = useState(false);
  const [actionItems, setActionItems] = useState([]);
  const [buttonStatus,setButtonStatus]=useState(true);

  const { hasPermission: createPilferage } = usePermissions('create', "pilferage");
  const { hasPermission: viewPilferage } = usePermissions('viewDetails', "pilferage");

    const preCompile = {
      warehouse: t('selectButtons.selWarehouse'),
      save:t('buttons.save')
    }


    React.useEffect(() => {
        getWarehouses();
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if(isDropDownOpen){
      setModalContHeight({height:'35vh'})
    }else{
      setModalContHeight({height:'auto'})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDropDownOpen]);

  useEffect(() => {
    setActionItems([
            {
                title: '',
                attribute: 'Items',
            },

        ]);
        setIsReloadTableData(true);
}, []);

const getActionCellIcons = (cellDef, data) => {

  if (cellDef.attribute === 'Items') {
      return [
          {src: viewIcon, value:"Items", title: 'View Items'},
      ];
  }


  return [];
};



const getWarehouseId=(w)=>{
  if(wareHouseArr.length){
    let warehouseObj=wareHouseArr.find( i => w === i.value)
    if(warehouseObj){
    return warehouseObj?.id.toString();
    }
    }
}

  const getWarehouses = async () => {
    try {
      const resp = await APIEndpoint.get('warehouses');
      if (resp && resp.result && resp.result.length) {
        setWareHouseArr(resp.result);
        const options = [{key: 0, label: preCompile.warehouse, value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.value}`});
          return fieldValue;
        });
        AddFormFields.map( row => {
          if (row.attribute === "warehouses" ) {
            row.options = options;
          }
          return row;
        });
      }
    } catch (error) {

    }

}
    const filterData = {
        action: 4,
        collection: '',
        filterOperation: 'or',
        filters: [],
        limit: 50,
        page: 1,
        searchParam: ''
    };
    const fetchPilferages = async (page=1, perPage=50) => {
      try {
        filterData.page = page;
            filterData.limit = perPage;
            filterData.searchParam = searchKey;
            const res = await APIEndpoint.post('warehouses/pilferage/process', JSON.stringify(filterData));
            return res;
      } catch (error) {

      }


    };

    const onSearch = (e) => {
        setSearchKey(e.target.value);
    };

    const onAction = (e, action, selectedRowData) => {
        setState( (_prev) => {
          return { ..._prev, selected: {...selectedRowData, code:selectedRowData.code, action: action.value }}
        });
      };
      const onAddItemHandler = () => {
        getWarehouses();
        setState( (_prev) => {
          return { ..._prev, selected: { action: 'AddPilferage' } };
        });
      }

      const onClose = () => {
        setState((_prev) => {
          return { ..._prev, selected: false }
        });
        setIsDropdownOpen(false);
        setModalContHeight({height:'auto'})
        setButtonStatus(true)
      }

const handleFormSubmit = async (e,updated) => {
if(updated?.warehouses){
 let id = getWarehouseId(updated.warehouses);
  if(id){
  try {
        navigate(`/procurement/pilferage-reporting/pilferage/warehouses/${id}`);
      }
     catch (error) {

     }
  }

}
      }

      const onFieldChangeHandler = (e,updated) => {
        if(!updated?.warehouses ){
          setButtonStatus(true)
        }else if(updated?.warehouses){
          setButtonStatus(false)
        }
      };

    return (
      <>
        <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
          {
            <>
            <div className="flexRow width100 margBot10 margTop8 justifyContentSpaceBetween alignItemsCenter">
              <div className="flexRow width100 margBot10 margTop8 justifyContentSpaceBetween">
                <div className="width100Menu justifyContentCenter flexRow">
                  <div className="margLeft margBot10 underline">
                    <span>
                      <img
                        className="icon-size"
                        alt={t("filters.searchText")}
                        src={searchIcon}
                      />
                    </span>
                    <span>
                      <input
                        className="search"
                        onChange={onSearch}
                        type="search"
                        placeholder={t("filters.searchText")}
                        value={props.searchKey}
                      />
                    </span>
                  </div>
                </div>
             {createPilferage? <div className="margLeft flexRow justifyContentFlexEnd alignItemsBaseline">
                  <button className="add-item-button" onClick={onAddItemHandler}>
                    {t("buttons.pilferage")}
                  </button>
                </div>:<></>}
              </div>
              </div>
              <DataGrid
                className="full-flex"
                columns={Columns}
                initialPageLimit={pageLimit}
                showDefaultFilters={false}
                searchKey={searchKey}
                getRows={fetchPilferages}
                getActionCellIcons={getActionCellIcons}
                rowSelection="multiple"
                actions={actionItems}
                resetDataSource={isReloadTableData}
                onAction={onAction}
                columnResize={true}
              />
            </>
          }
          {state && Boolean(state.selected) && state.selected?.action === "Items" && viewPilferage &&(
            <EditModal
              key={state.selected?.action}
              showDone={false}
              title={`Pilferage - ${state.selected?.code}`}
              onClose={onClose}
              fields={EditFormFields.map((elt) => {
                return { ...elt, initialValue: state.selected[elt.attribute] };
              })}
            />
          )}
          {state &&
            Boolean(state.selected) &&
            state.selected?.action === "AddPilferage" && (
              <EditModal
                key={state.selected?.action}
                title={"Create Pilferage"}
                buttonLabel={preCompile.save}
                onSubmit={handleFormSubmit}
                customContentHeight={ModalContHeight}
                setIsDropdownOpen={setIsDropdownOpen}
                showFieldsInColumn={true}
                onClose={onClose}
                onChange = {onFieldChangeHandler}
                disabled={buttonStatus}
                fields={AddFormFields.map((elt) => {
                  return { ...elt, initialValue: state.selected[elt.attribute] };
                })}
              />

            )}
          {!ready && (
            <div className="overlay_hide sub"></div>
          )}
        </div>
      </>
    );
}

